import en from "./en.json";

const language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

let lang;

switch (language) {
  case "en-US":
    lang = en;
    break;
  default:
    lang = en;
}

export default lang;
